import { createElement } from 'react';
import { OmitStrict } from '../../utility-types';
import { BaseTable, BaseTableProps } from './__internal__/internal';
import './Table.css';

export interface TableDragDropRef {
  displayDropIndicator(index: number, clearEmptyZone?: boolean): void;
  hideDropIndicator(): void;
}

export interface TableRef {
  getColumnIndexForOffset: (scrollLeft: number) => number;
  getRowIndexForOffset: (scrollTop: number) => number;
  setSelectedRows: (rowKeys: Array<string>) => void;
  setSelectAll: (selectAll: boolean) => void;
}
export interface TableProps
  extends OmitStrict<BaseTableProps, 'narratorRef' | 'hideFillRows' | 'renderRow' | 'internalRef'> {
  selectionMode?: Exclude<BaseTableProps['selectionMode'], 'singleRadio' | 'toggle'>;
}

/**
 * The Table component enables you to display data in a grid format.
 */
export const Table = (props: TableProps) => {
  return <BaseTable {...props} />;
};
